// extracted by css-extract-rspack-plugin
export default {"Box":"label-module__Box__sep7thf","StateLabel":"label-module__StateLabel__ZMHtpkd","Text":"label-module__Text__6wrYAyc"};